export function UserListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserListing', {
		url: '/admin/users',
		controllerAs: 'vm',
		controller: UserListingCtrl,
		templateUrl: '/ng/hub/User/Listing/UserListingCtrl.html?' + window.BUILD,
		permission: ['manage_users'],
		resolve: {
			$title: () => 'Manage Users',
		},
	});
}

export class UserListingCtrl {
	constructor($state, Api, modal, $timeout, $location, Identity, $filter, notifications) {
		'ngInject';
		// save injections
		this.$state = $state;
		this.Api = Api;
		this.modal = modal;
		this.$timeout = $timeout;
		this.$location = $location;
		this.notifications = notifications;
		// setup user listing table
		this.filters = { role: '!observer', term: '' };
		this.headers = { Hubs: 'current' };
		this.image = { field: 'avatar', width: 24, height: 24, alt: '', label: '' };
		this.columns = [
			{ field: 'email', label: 'Email', sortable: true },
			{ field: 'fname', label: 'First Name', sortable: true },
			{ field: 'lname', label: 'Last Name', sortable: true },
			{ field: 'fname_preferred', label: 'Preferred First', sortable: true },
			{ field: 'lname_preferred', label: 'Preferred Last', sortable: true },
			{ field: 'role', label: 'Access Level', sortable: false },
			{ field: 'created_at', label: 'Created', sortable: true },
			{ field: 'last_login', label: 'Last Login', sortable: true },
		];
		this.actions = [{ label: 'Edit', icon: null, callback: this.editUser.bind(this) }];
		if (Identity.isSuperadmin()) {
			this.actions.push({
				label: 'Impersonate',
				icon: null,
				callback: this.impersonateUser.bind(this),
			});
			this.columns.push({
				field: 'id',
				label: 'ID',
				sortable: false,
			});
		}
		this.limit = 10;
		// filter by role
		this.roles = [
			{ name: 'Filter by role...', value: '!observer' },
			{ name: 'Account Manager', value: 'account manager' },
			{ name: 'Editor/Intel Leader', value: 'intel leader' },
			{ name: 'Client', value: 'executive' },
			{ name: 'Member', value: 'member' },
		];
		// filter by hub type
		this.hubScopes = [{ id: 'current', name: 'Include: this hub' }];
		if (Identity.isSuperadmin()) {
			this.hubScopes.push({ id: 'account', name: 'Include: this account' });
		}
		if (Identity.hasMultipleHubs()) {
			this.hubScopes.push({ id: 'mine', name: 'Include: all my hubs' });
		}
		// transformer: handle dates
		const dateFormat = $filter('shDate');
		this.transformer = records => {
			records.data.forEach(user => {
				user.created_at = dateFormat(user.created_at, 'long');
				user.last_login = dateFormat(user.last_login, 'long', '(never)');
			});
			return records;
		};
	}

	$onInit() {
		const { message } = this.$location.search();

		if (message) {
			// $timeout makes angular and the external library play nice
			this.$timeout(() => this.notifications.showSuccess({ message, hideDelay: 2000 }));
		}
	}

	editUser(user) {
		window.location.href = this.$state.href('hub.loggedin.UserEdit', { id: user.id });
	}

	impersonateUser(user) {
		this.Api.get(`/users/${user.id}/impersonate?referer=${encodeURIComponent(window.location.href)}`)
			.then(({ payload, token, url }) => {
				localStorage.setItem('jwt', JSON.stringify({ payload, success: true, token }));
				window.location.href = `${url}`;
			})
			.catch(error => {
				this.notifications.showError({
					message: `Could not impersonate, we ran into the following error: "${error.message}"`,
				});
			});
	}

	importUsers() {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.UserImport', {
				heading: `Import Users`,
				height: 680,
				width: 750,
			})
			.then(reload, reload)
			.catch(() => {
				this.notifications.showError({ message: 'We ran into an error during the import.' });
			});
	}

	addUser() {
		// TODO: edit in modal

		window.location.href = `${window.BASE_URL}/core/admin/users/add`;
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}
}
